import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Charges section for FAQ Page
 */
const ChargesSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="charges-section-component"
    >
      <AccordionV2
        testId="charges"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="Are there any charges involved in participating in these awards?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 mt-2 px-6 py-4 pb-0">
          <p>There is no fee incurred in participation.</p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ChargesSection;
